import { Phone, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { companyInfo } from "../data/mock";

export const Hero = () => {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden bg-gradient-to-br from-slate-50 via-white to-slate-50">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-slate-100 rounded-full opacity-50 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-slate-100 rounded-full opacity-50 blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="bg-slate-900 text-white px-4 py-2 rounded-full text-sm font-semibold">
                🚗 Hackney's #1 Car Recovery & Transport Service
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
              24/7 Car Recovery & Vehicle Transport in Hackney, East London
            </h1>

            <p className="text-lg text-slate-600 leading-relaxed">
              Emergency breakdown recovery, auction transport, and car towing across Hackney and East London. Covering E postcodes and 20-mile radius with 30-minute response times. Available 24/7 for all your vehicle recovery needs in Hackney, Shoreditch, Stratford, and surrounding areas.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button 
                onClick={scrollToQuote}
                size="lg"
                className="bg-slate-900 hover:bg-slate-800 text-white text-lg px-8 py-6 group"
              >
                Get Instant Quote
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>

              <a href={`tel:${companyInfo.emergencyPhone}`}>
                <Button 
                  size="lg"
                  variant="outline"
                  className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white text-lg px-8 py-6 w-full sm:w-auto"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Emergency Call
                </Button>
              </a>
            </div>

            {/* Trust indicators */}
            <div className="grid grid-cols-3 gap-4 pt-8 border-t border-slate-200">
              <div>
                <p className="text-2xl font-bold text-slate-900">30 Min</p>
                <p className="text-sm text-slate-600">Response Hackney</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">20 Miles</p>
                <p className="text-sm text-slate-600">East London</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">24/7</p>
                <p className="text-sm text-slate-600">Available</p>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&q=80"
                alt="Professional car transport service"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
            </div>

            {/* Floating card */}
            <div className="absolute bottom-6 left-6 right-6 bg-white rounded-xl shadow-xl p-6 border border-slate-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <Phone className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-sm text-slate-600">Need Immediate Assistance?</p>
                  <a 
                    href={`tel:${companyInfo.emergencyPhone}`}
                    className="text-xl font-bold text-slate-900 hover:text-slate-700 transition-colors"
                  >
                    {companyInfo.emergencyPhone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
